import React from 'react';
import ServiceHero from '../../../components/service/ServiceHero';
import QuoteForm from '../../../components/home/QuoteForm';
import ServiceTrusted from '../../../components/service/ServiceTrusted';

import ServiceAsbuilt from '../../../components/service/ServiceAsbuilt';
import ServiceExplore from '../../../components/service/ServiceExplore';
import ServiceWorkflow from '../../../components/service/ServiceWorkflow';
import DesireTechSection from '../../../components/home/DesireTechSection';
import ModelsSection from '../../../components/home/ModelsSection';
import ProjectsSection from '../../../components/home/ProjectsSection';
import TestimonialsSection from '../../../components/home/TestimonialsSection';
import ServiceHiring from '../../../components/service/ServiceHiring';
import BestArchitectureSection from '../../../components/home/BestArchitectureSection';
import ServiceChoose from '../../../components/service/ServiceChoose';
import SoftwaresSection from '../../../components/home/SoftwaresSection';
import AwardsSection from '../../../components/home/AwardsSection';
import FAQSection from '../../../components/home/FAQSection';
import BlogsSection from '../../../components/home/BlogsSection';
import ContactSection from '../../../components/home/ContactSection';

const AsBuiltBimDrawingPage = () => {
  const asBuiltSteps = [
    {
      step: "Step 1",
      title: "Scan Data Intake & Review",
      desc: "We will review the point cloud or laser scan files that were provided by your team. Our specialists will evaluate the quality of the files provided, the overall scope of the project, and then use this information to develop an optimal modeling strategy."
    },
    {
      step: "Step 2",
      title: "Data Processing & Alignment",
      desc: "Using industry-standard software tools, such as Autodesk Recap, Revit and Navisworks, we will clean, register and align scanned data to ensure that every detail is geolocated and ready for modeling."
    },
    {
      step: "Step 3",
      title: "BIM Model Development",
      desc: "Based on your specific standards and desired Level of Development (LOD 100 to LOD 500) our professionals will develop highly-detailed Architectural, Structural and MEPF models. Each component will be modeled according to actual field conditions with accuracy."
    },
    {
      step: "Step 4",
      title: "AI-powered Quality Control & Final Delivery",
      desc: "Before delivery of the completed model, each model is validated through our proprietary quality control system according to 100+ established criteria. As a result, we provide you with a clean clash-free construction-ready BIM model that you can rely on."
    }
  ];

  const asBuiltFaqs = [
    {
      question: "What is the difference between Scan to BIM and As Built Modeling?",
      answer: "Scan to BIM is the method while As Built Modeling is the end-product showing actual site conditions as a result of using scan data."
    },
    {
      question: "What formats do you deliver in?",
      answer: "We deliver files in Revit (.RVT), Navisworks (.NWD), DWG, IFC and COBie-compliant spreadsheets; the required format(s) will be identified by the customer."
    },
    {
      question: "Can you create a model using only an old drawing with no scan data?",
      answer: "Yes. We can perform a CAD to BIM conversion or a manual as-built model from record drawings that have been marked-up."
    },
    {
      question: "What types of industries do you serve?",
      answer: "Your industries would include but not limited to commercial industrial retail, hospital, airport; data centers; etc. throughout the United States."
    },
    {
      question: "Do you provide LOD-specific models?",
      answer: "Absolutely. We specialize in providing models ranging from LOD 100 (Conceptual) to LOD 500 (As-built/Facility Management), depending on your specific requirements."
    }
  ];

  const choosePoints = [
    {
      title: "Digital Models that are True-to-Reality",
      desc: "We create accurate 3D BIM models of your entire building (architectural, structural, and MEP) based on point clouds provided by the client. When we are done, these models have no errors and are a precise representation of how the building exists."
    },
    {
      title: "Easier Renovations and Retrofits",
      desc: "When in Revit, the verified as-built conditions will provide you with a reliable source of information when developing renovation and retrofit designs, making it less likely that you will encounter unknown issues during construction, thereby reducing change orders and keeping your costs down."
    },
    {
      title: "Faster Turnarounds and Lower Costs",
      desc: "Thanks to optimized processes and an experienced team, we can rapidly produce an accurate, high-quality model that will save you time and money. This is particularly true for fast-tracked or large-scale redevelopment projects."
    },
    {
      title: "Improved Facility Management",
      desc: "With accurate, data-rich models, FM teams can use the models for preventative maintenance, assist with space planning, and manage the lifecycle of your assets, resulting in optimal operating efficiency and cost savings."
    },
    {
      title: "Regulatory-Ready Documentation",
      desc: "Creating an electronic version of physical objects such as buildings or roads is called a “digital twin”. This process can help ensure that buildings meet predetermined standards and aid in meeting both planned and unplanned audits and inspections, as well as future upgrades."
    },
    {
      title: "Minimized Risk and Greater Predictability",
      desc: "By establishing your validated as-built model prior to beginning construction, you will avoid potential errors in the form of construction errors, misalignment, and timelines, by using the model's as-built data to construct your digital model."
    },

  ];

  return (
    <div className="as-built-drawing-page">
      <style jsx>{`
        .as-built-drawing-page :global(section) {
          padding-top: 30px !important;
          padding-bottom: 30px !important;
        }
        .as-built-drawing-page :global(.service-description),
        .as-built-drawing-page :global(.explore-subtitle),
        .as-built-drawing-page :global(.asbuilt-text),
        .as-built-drawing-page :global(.service-hiring-description),
        .as-built-drawing-page :global(.hiring-card-text),
        .as-built-drawing-page :global(.service-choose-subtitle),
        .as-built-drawing-page :global(.desire-tech-subtitle) {
          max-width: 1000px !important;
          margin-left: auto !important;
          margin-right: auto !important;
          color: #ffffff !important;
        }
        .as-built-drawing-page :global(.hero-btn:hover),
        .as-built-drawing-page :global(.trusted-btn:hover),
        .as-built-drawing-page :global(.onboarding-cta:hover),
        .as-built-drawing-page :global(.desire-tech-btn:hover) {
          background-color: #ffffff !important;
          color: #54b248 !important;
          border-color: #54b248 !important;
        }
      `}</style>
      <ServiceHero
        overline="As-Built BIM Modeling Services"
        staticTitle={<><span className="text-primary">As-Built BIM Drawing Services in USA —</span></>}
        typingWords={["Get 99% Accurate Existing Building Models"]}
        description="Scan to BIM Service Company provides as-built modeling and drawing services to the US construction projects, converting the raw scan data into the correct BIM models, which are used in renovation, facility management, and documentation of the project."
        buttonText="Hire react developers now"
      />
      <QuoteForm customStyle={{ marginTop: '0px' }} />
      <ServiceTrusted
        title={<><span className="text-primary">As-Built Drawing &</span> Documentation Services</>}
        paragraphs={[
          "As one of the top Scan-to-BIM services, we have become well-known as the best choice to provide As Built drawings, 3D laser scanning and BIM documentation for you. We can guarantee accurate As Built documentation of all types of projects (residential, retail, commercial) throughout the United States. As a leading service provider we use the latest LiDAR 3D laser scanning equipment and BIM technology to provide an accurate representation of all architectural and structural features.",
          "Our services include; floor plans, elevations, sections, CAD drawings and 3D Revit models which will all meet the requirements necessary for use in design, renovations, or facility management. We guarantee our speed, consistency and reliability at every stage of Scan-to-BIM modeling, 2D As Built drawings and site surveys."
        ]}
        buttonText="Book a Meeting"
      />
      <ServiceAsbuilt />
      <ServiceExplore />

      <DesireTechSection
        title={<><span className="text-primary">Let's Discuss Your</span> As-Built BIM Modeling Needs</>}
        subtitle="Connect with us and work with our experienced BIM specialists to create accurate, data-rich as-built models that reflect your project conditions."
        buttonText="Book a Free Consultation"
      />
      <ServiceWorkflow
        title={<> <span className="text-primary">Our As-Built BIM Modeling</span> Workflow for Delivering Accurate</>}
        description="Our structured workflow is based on providing a precise, accurate approach to produce as-built models. Our goal is to provide a reliable, accurate as-built model that can be utilized for practical, real-world applications."
        steps={asBuiltSteps}
        buttonText="Choose Your Model"
      />
      <ProjectsSection />
      <TestimonialsSection />
      <ModelsSection />
      <ServiceHiring />
      <BestArchitectureSection />
      <DesireTechSection
        title={<><span className="text-primary">Looking for accurate</span> As-built BIM Models?</>}
        subtitle="Connect with our experts and get precise, data-rich BIM models tailored to your project requirements."
        buttonText="Connect With a Teach Expert"
      />
      <ServiceChoose
        title={<><span className="text-primary">Why Choose As-Built BIM</span> Modeling for Your Project?</>}
        subtitle="With our As-Built BIM Modeling Services, you will have superior accuracy and control of your project – ultimately reducing risk, saving time and improving every phase of your asset's lifecycle."
        points={choosePoints}
      />
      <SoftwaresSection />
      <AwardsSection />
      <FAQSection
        subtitle="Get quick answers to FAQ's for first time customers looking to learn about our service."
        faqs={asBuiltFaqs}
      />
      <BlogsSection />
      <ContactSection />
    </div>
  );
};

export default AsBuiltBimDrawingPage;
